<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow' : visible}"
    :style="visible ? 'display:block;': ''"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center mt-4">
            <span class="material-icons text-blue-2" style="font-size: 77px"> new_releases </span>
          <h5 class="modal-title">Estas trabajando con una versión beta, solo podrás subir productos o servicios. En muy poco tiempo podrás comenzar a comprar.</h5>
          
        </div>
        <div class="p-3 text-center">
          <span class="btn btn-treid" @click="handleClilickSend">Entiendo</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalWarningLogin",
  props: {
    visible: Boolean,
  },
  methods: {
    handleClilickSend(){
      this.$router.push('/');
    }
  }
};
</script>
<style lang="css" scoped>
</style>